import dashboardRoutes from './dashboard/_routes'

import accountRoutes from './account/_routes'
import mapFeeHead from './mapfeehead/_routes'
import inventory from './inventory/_routes'
let routes = [ ...accountRoutes, ...dashboardRoutes, ...mapFeeHead, ...inventory];
export default routes;